import { ErrorPacket, Next, Pipe } from '../types';
import { BaseException } from '../../base-exception';

export class BaseExceptionPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        if (!(packet.data instanceof BaseException)) {
            return next(packet);
        }

        return {
            ...packet,
            result: packet.data.getAppError(),
        };
    }
}
